module.exports = __webpack_public_path__ + "img/8.060c1853.png";